module.exports = __webpack_public_path__ + "static/gtri-logo-89f4d6cdbfd3bf26781be763d8e7f27c.png";